import React, { useState } from "react";
import { useSnackbar } from "notistack";
import { TrendObject } from "../interface";
import { useSpring, animated } from "react-spring";
import { isMobile } from "react-device-detect";

export const TrendCard = ({ item }: TrendObject) => {
  const { enqueueSnackbar } = useSnackbar();
  const [show, setShown] = useState(false);

  const props3 = useSpring({
    transform: show ? "scale(1.03)" : "scale(1)",
  });

  const handleCopy = (text: string) => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          handleClickSnackbar("contracts address is already in your Clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    } else {
      fallbackCopyTextToClipboard(text);
    }
  };

  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      handleClickSnackbar("contracts address is already in your Clipboard");
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  };

  const handleClickSnackbar = (message: string) => {
    enqueueSnackbar(message, {
      variant: "success",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
    });
  };

  const handleLinkClick = async (name: string, type: string, url: string) => {
    if (url !== "") {
      window.open(url, "_blank");
      traceLink(name, type, url);
    }
  };

  const traceLink = async (name: string, type: string, url: string) => {
    try {
      if (name !== "" && type !== "") {
        await fetch("/v1/api/fetchAttr", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, type }),
        });
      }
    } catch (error) {
      console.error("click error:", error);
    }
  };

  return (
    <animated.div
      style={props3}
      className={isMobile ? "mt-[-5rem]" : ""}
      onMouseEnter={() => setShown(true)}
      onMouseLeave={() => setShown(false)}
    >
      <div className="nft">
        <div className="main">
          <img
            className="tokenImage"
            src={
              "./images/nfts/" +
              (item?.image_url !== "" ? item?.collection : "no-image") +
              ".png"
            }
            alt={item?.collection}
          />
          <div className={"flex align-items-center mt-[12px]"}>
            <h2 className={"flex-1  leading-[24px]"}>{item?.name}</h2>
            {item?.role > 0 ? (
              <div className={"flex"}>
                <svg viewBox="0 0 30 30" width="30" height="30">
                  <circle
                    fill={item.color}
                    className="circle"
                    cx="16"
                    cy="16"
                    r="12"
                  />
                </svg>
                <img
                  width={25}
                  src={"./images/roles/" + item.role.toString() + ".svg"}
                />
              </div>
            ) : (
              ""
            )}
          </div>

          <p className="description">{item?.description}</p>
          <div className="tokenInfo">
            <div className="price"></div>
            <div className="duration">
              <div
                title={"click to copy contracts address"}
                className={"mr-[5px] mb-[5px]"}
                onClick={() => handleCopy(item?.contracts_address)}
              >
                <img
                  width={28}
                  height={28}
                  src={"./images/" + item?.contracts_chain + ".png"}
                  alt={item?.contracts_chain}
                />
              </div>

              <p>{item?.created_date}</p>
            </div>
          </div>
          <hr />
          <div className="creator">
            <div
              className="wrapper"
              title={"OpenSea"}
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick(
                  item?.collection,
                  "opensea",
                  "https://opensea.io/collection/" + item?.collection,
                );
              }}
            >
              <img src="/images/opensea.png" alt="opensea" />
            </div>
            {item?.discord_url !== "" && (
              <div
                className="wrapper"
                title={"Discord"}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(item.collection, "discord", item.discord_url);
                }}
              >
                <img src="/images/discord.png" alt="discord" />
              </div>
            )}
            {item?.twitter_url && (
              <div
                className="wrapper"
                title={"X"}
                style={{ marginLeft: "1px" }}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(
                    item.collection,
                    "twitter",
                    "https://x.com/" + item.twitter_url,
                  );
                }}
              >
                <img src="/images/twitter.png" alt="twitter" />
              </div>
            )}
            {item?.telegram_url && (
              <div
                className="wrapper"
                title={"Telegram"}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(
                    item.collection,
                    "telegram",
                    item.telegram_url,
                  );
                }}
              >
                <img src="/images/telegram.png" alt="telegram" />
              </div>
            )}
          </div>
        </div>
      </div>
    </animated.div>
  );
};
